import { formatPartialDate, partialDateFromDate } from 'neuro-utils';
import colors from '../../../../../../../config/theme/colors';

const FilesTable = ({ pictures = [], fm, isEditing }: IFilesTable) => {
  const picturesSorted = pictures.toSorted((a, b) => {
    const aDate = a.date ? new Date(a.date) : new Date(a._docCreateDate);
    const bDate = b.date ? new Date(b.date) : new Date(b._docCreateDate);
    return bDate.valueOf() - aDate.valueOf();
  });

  return (
    <div style={{ marginBottom: '2rem' }}>
      <table style={{ width: '100%', borderSpacing: '0px' }}>
        <thead>
          <tr style={{ textAlign: 'left', color: colors.darkGray }}>
            {['pictureName', 'pictureDate'].map(header => (
              <th key={header} style={{ padding: '0 1rem' }}>
                {fm('rtms.subjectOfTreatment.' + header)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {picturesSorted.map((pic, ind) => (
            <tr
              key={pic._id}
              style={{
                backgroundColor: ind % 2 === 0 ? colors.lightestGray : colors.white,
                color: colors.black,
                height: '4rem',
              }}
            >
              <td style={{ padding: '0 1rem', textDecoration: 'underline', cursor: 'pointer' }}>
                <a href={`/attachments/${pic.fileContentId}`} rel="noreferrer" target="_blank">
                  <div style={{ maxWidth: '30rem' }} className="ellipsis">
                    {(pic.name as string | undefined) ?? fm('rtms.subjectOfTreatment.noName')}
                  </div>
                </a>
              </td>
              <td style={{ padding: '0 1rem' }}>
                {pic.date && formatPartialDate(partialDateFromDate(new Date(pic.date)))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

interface IFilesTable {
  pictures: Array<IDocumentWithTypeV2<'filestorefile'>>;
  fm: (id: string) => string;
  isEditing: boolean;
}

export default FilesTable;
